import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAlignTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutAlignTopBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 15V17H17V15H7ZM7 9H17V7H7V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAlignTopBottom;
